import { validateRequired } from '@ion/components/src/components/form/validators';

export default function buildConsentCategoryModeSelectProps({ formState, setField, ...props }) {
  // Mode change always clears the dependent consentCategory field
  // - External forbids a category
  // - ACE requires a fresh pick after a mode change
  const onChange = event => {
    setField(event, { otherFields: [{ name: 'consentCategory', value: '', errorMsg: null }] });
  };

  return {
    onChange,
    validators: [validateRequired()],
    value: formState.consentMode.value,
    errorMsg: formState.consentMode.errorMsg,
    label: 'Select Consent Mode',
    ...props,
  };
}
